import { render, staticRenderFns } from "./SupportTicketsReply.vue?vue&type=template&id=28ba0f15&"
import script from "./SupportTicketsReply.vue?vue&type=script&lang=js&"
export * from "./SupportTicketsReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports